<template>
    <div class="waiting">
        <div class="waiting-main">
            <div v-if="role" class="teacher">
                <p class="waiting-title">点击资源、签到和活动后将自动投到大屏幕哦~</p>
                <p class="class-information" v-if="waiting">
                    <span>班课号: {{ invitationCode }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>班课名称: {{ clazzName }} </span>
                    <span>{{ courseName }} </span>
                </p>
            </div>
            <div v-else class="student">
                <p class="waiting-title">投屏功能暂时只可以在【我创建的】<br/>和以老师角色加入的【我共建的】班课中使用</p>
            </div>
            <div class="waiting-content">
                <div class="light">
                    <img src="../assets/image/light.png" alt="">
                </div>
                <p class="waiting-tips" v-text="waitingText[random]"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentShow: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            supportedEventNames: [
                'common.enterCC',
                'common.waiting'
            ],
            waitingTitle: '操作中，请耐心等候',
            // waitingText: '你可以使用锁屏功能保持大屏幕内容不变',
            waitingText: [
                '你可以使用锁屏功能保持大屏幕内容不变',
                'App 中的投屏浮窗是可以移动的哟～',
                '投屏时，投屏端打开音效，体验更佳哦～',
                '后排同学看不太清？在 App 中试试调节字体大小吧～',
                '投屏过程中想要查看其他活动，又不想影响学生看当前内容？“锁定投屏”功能助你一臂之力！',
                '进入“锁定投屏”状态后，你在 App 中的操作将不再影响大屏幕的显示了哟！～',
                '“锁定投屏”状态下，大屏幕中活动的内容还会自动更新哦～',
                '解除锁定后，大屏幕将同步显示手机当前的内容哦～',
                '你可以同时连接多个大屏幕哦～',
                '字体不够大？试试“调节字体大小”功能吧～',
                '你知道吗？只有进行中和已结束的活动可以投屏呢～',
                '点击投屏浮窗能够召唤投屏工具栏哦～',
                '投屏工具栏中的“连接屏幕”能够增加或减少连接的屏幕个数哦～',
                '投屏上的内容看不全？“摇杆”来帮你！',
                '退出投屏后，需要再次连接才可以继续使用哦～',
                '请不要错点工具栏的“退出投屏”哦，不然学生就看不到精彩的内容啦～',
                '视频和音频也可以投屏哦，还可以在手机上直接控制进度和音量呢！～',
                '投屏过程中，双击投屏浮窗可以快速地开启和关闭锁定投屏功能哦！～'
            ],
            random: 0,
            ccId: null,
            role: true,
            clazzName: null,
            courseName: null,
            invitationCode: null,
            waiting: false,
        };
    },

    computed:{
    },


    watch:{
        currentShow: function(newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                // this.resetScene();
                this.tipsRandom();
            }
        }, 
    },
    

    created: function() {

    },
    
    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },
    
    methods:{
        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg) return;
            if ( ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            const msgData = msg.data;
            switch (msg.eventName) {
                case 'common.enterCC':
                    this.commonEnterCC(msgData);
                    break;
                case 'common.waiting':
                    this.commonWaiting(msgData);
                    break;
                default:
                    break;

            }
        },

        commonEnterCC: function(msgData) {
            this.waiting = true;
            this.ccId = msgData.ccId;
            if (!msgData.role) return;
            if (msgData.role === 1 || msgData.role === 4) {
                this.role = true;
                this.clazzName = msgData.clazzName;
                this.courseName = msgData.courseName;
                this.invitationCode = msgData.invitationCode;
            } else {
                this.role = false;
            }
        },

        commonWaiting: function(msgData) {
            if (msgData.length == null) {
                this.waiting = false;
                return;
            };
            this.waiting = true;
            this.clazzName = msgData.clazzName;
            this.courseName = msgData.courseName;
            this.invitationCode = msgData.invitationCode;
        },

        resetScene: function() {
            this.role = true;
            this.clazzName = null;
            this.courseName = null;
            this.invitationCode = null;
        },
        
        tipsRandom: function() {
            this.random = Math.round(Math.random() * (this.waitingText.length +1));
            if (this.random > this.waitingText.length - 1) this.random = 0;
        }
    }
};
</script>

<style>
    .waiting {
        z-index: 99;
        background-color: #252525;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .waiting-title {
        font-size: 48px;
        color: #FFFFFF;
        text-align: center;
    }

    .class-information {
        font-size: 24px;
        color: #FFFFFF;
        padding-top: 20px;
    }

    .waiting-content {
        width: 748px;
        border-radius: 8px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: 0 auto;
        margin-top: 84px;
        padding: 20px 20px;
    }
    .waiting-content .light {
        width: 80px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -48px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 0;
    }
    .waiting-content .light > img {
        width: 50px;
        height: 50px;
    }
    .waiting-tips {
        font-size: 1.125rem;
        line-height: 3rem;
        color: #666666;
    }
</style>